import React from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function usePrevious(value: any, initialValue?: any) {
  const ref = React.useRef(initialValue)

  React.useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
